import serviceTasksRepositoriesApiService from '@/services/api/ServiceTasksRepositories'

const emptyModel = {
  id: null,
  title: null,
  service_task_type_id: null,
  order: null,
  wintering: false,
  description: null
}

const emptyFilters = {
  title: null,
  service_task_type_id: null,
  wintering: null
}

class ServiceTaskRepository {
  constructor() {
    this.api = serviceTasksRepositoriesApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
  }
}

let serviceTaskRepository = new ServiceTaskRepository()

export default serviceTaskRepository
